import PropTypes from 'prop-types';

export const delayShape = PropTypes.shape({
  quantity: PropTypes.number,
  unit: PropTypes.string,
});

export const generationSettingsShape = PropTypes.shape({
  instructions: PropTypes.string,
  type: PropTypes.string,
  generator: PropTypes.string,
  template: PropTypes.string,
  incentive: PropTypes.string,
  delay: delayShape,
});

export const emailShape = PropTypes.shape({
  enabled: PropTypes.bool,
  destinations: PropTypes.arrayOf(PropTypes.string),
});

export const channelsShape = PropTypes.shape({
  email: emailShape,
});

export const notificationSettingsShape = PropTypes.shape({
  frequency: PropTypes.string,
  channels: channelsShape,
});

export const valueShape = PropTypes.shape({
  generationSettings: generationSettingsShape.isRequired,
  notificationSettings: notificationSettingsShape.isRequired,
});
